// extracted by mini-css-extract-plugin
export var centerText = "_df-8";
export var container = "_df-0";
export var doughnutContainer = "_df-7";
export var legend = "_df-a";
export var legendItemColorDisplay = "_df-b";
export var legendItemLabel = "_df-d";
export var legendItemValue = "_df-c";
export var lg = "_df-5";
export var maxWidth = "_df-9";
export var md = "_df-4";
export var responsive = "_df-6";
export var sm = "_df-3";
export var xs = "_df-2";
export var xxs = "_df-1";